import React from 'react'
import { Stack } from '@sureco/design-system'
import EnrollmentConfiguration from './components/EnrollmentConfiguration'

export default function EnrollmentTab({ id }: { id: string }) {
  return (
    <Stack space={20}>
      <EnrollmentConfiguration id={id} />
    </Stack>
  )
}
